<div class="all" mat-dialog-content>
  <lemon-dialog-header [naytaSuljeRuksi]="false" [naytaOtsikko]="false"></lemon-dialog-header>
  <h2 class="light-blue-text otsikko">
    <mat-icon>inventory_2</mat-icon>
    {{ (data.tuote ? 'tuote.dialog.muokkaa-otsikko' : 'tuote.dialog.lisaa-otsikko') | translate | async }}
  </h2>
  @if (data.tuote) {
    <div class="huomautus-oranssi">{{ 'tuote.dialog.huomautus' | translate | async }}</div>
  }

  <form novalidate>
    <div class="kentat">
      <mat-form-field class="leveä">
        <mat-label>{{ 'tuote.nimi' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.nimi" matInput data-lpignore="true" />
        @if (onkoVirhe(lomake.nimi, 'required')) {
          <mat-error>{{ 'tuote.validation.nimi.required' | translate | async }}</mat-error>
        }
        @if (onkoVirhe(lomake.nimi, 'minLength')) {
          <mat-error>{{ 'tuote.validation.nimi.minlength' | translate | async }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'tuote.dialog.hinta-veroton' | translate | async }}</mat-label>
        <input decimalNumberField [numberOfDecimals]="2" [formField]="lomake.hinta" matInput />
        @if (verollinenHinta(); as verollinenHinta) {
          <mat-hint>{{ 'tuote.dialog.sis-alv' | translate | async }} {{ verollinenHinta | lmoney: lomake.valuutta().value() | async }}</mat-hint>
        }
        @if (onkoVirhe(lomake.hinta, 'required')) {
          <mat-error>{{ 'tuote.validation.hinta.required' | translate | async }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'tuote.dialog.valuutta' | translate | async }}</mat-label>
        <mat-select [formField]="lomake.valuutta">
          @if (onkoValuutaton) {
            <mat-option [value]="eiValuuttaa">{{ 'tuote.dialog.ei-valuuttaa' | translate | async }}</mat-option>
          }
          @for (valuutta of valuutatObservable | async; track valuutta.koodi) {
            <mat-option [value]="valuutta.koodi">{{ valuutta.koodi }} ({{ 'valuutta.' + valuutta.koodi | translate | async }})</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <app-yksikko-haku [yksikko]="lomake.yksikko().value()" [naytaKenttana]="true" [otsikko]="'tuote.dialog.yksikko' | translate | async" (yksikkoValittu)="asetaYksikko($event)"></app-yksikko-haku>

      <mat-form-field>
        <mat-label>{{ 'tuote.dialog.alv' | translate | async }}</mat-label>
        <mat-select [formField]="lomake.alv" [compareWith]="vertaaAlvt">
          @for (alv of alvt(); track alv.tunniste) {
            <mat-option [value]="alv">{{ alv.prosentti | ldecimal: 2 | async }} %</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (naytetaankoVerottomuudenPeruste) {
        <mat-form-field class="leveä">
          <mat-label>{{ 'tuote.dialog.verottomuuden-peruste' | translate | async }}</mat-label>
          <mat-select [formField]="lomake.verottomuudenPeruste">
            @for (peruste of verottomanMyynninPerusteet; track peruste) {
              <mat-option [value]="peruste">{{ 'verottoman-myynnin-peruste.' + peruste | translate | async }}</mat-option>
            }
          </mat-select>
          @if (onkoVirhe(lomake.verottomuudenPeruste, 'required')) {
            <mat-error>{{ 'tuote.validation.verottomuuden-peruste.required' | translate | async }}</mat-error>
          }
        </mat-form-field>
      }
    </div>
  </form>

  <div class="napit">
    @if (data.tuote) {
      <button class="poista-nappi" mat-button (click)="poistaTuote()" type="button">
        <mat-icon>delete</mat-icon>
        {{ 'tuote.dialog.poista' | translate | async }}
      </button>
      <span class="kasvata"></span>
    }
    <button class="secondarybutton" mat-button mat-dialog-close type="button">{{ 'yleiset.peruuta' | translate | async }}</button>
    <button class="primarybutton" mat-button (click)="tallenna()" type="button">{{ (data.tuote ? 'tuote.dialog.tallenna' : 'tuote.dialog.lisaa') | translate | async }}</button>
  </div>
</div>
